const InputValidationBehavior = {
  initial: 'onBlur',
  whenTouched: 'onChange',
  whenSubmitted: 'onChange',
} as const

const SnackbarAutoHideDuration = 10000 // 10s

const TabDefaultPrefix = "Client Area"
const TabTitleSuffix = ['TheTradingPit']
const TabTitleSeparator = " | "

const CDN_URI = "https://s3.eu-west-1.amazonaws.com/cdn.thetradingpit.com/client-area/locales"

const TradingRulesCacheTTLMs = 15 * 60 * 1000 // 15 minutes

export const AppConfig = {
  InputValidationBehavior,
  SnackbarAutoHideDuration,
  TabTitleSuffix,
  TabTitleSeparator,
  TabDefaultPrefix,
  CDN_URI,
  TradingRulesCacheTTLMs
} as const
